import getInstrumentationContextsFromTableView from 'owa-mail-list-store/lib/utils/getInstrumentationContextsFromTableView';
import getItemIdsFromConversations from 'owa-mail-list-store/lib/utils/getItemIdsFromConversations';
import markItemsJunkNotJunkBasedOnItemIds from '../markItemsJunkNotJunkBasedOnItemIds';
import { actionNames, DeleteConversationStoreUpdate } from 'owa-mail-store-actions';
import { ActionSource } from 'owa-analytics-actions';
import { getRowIdsFromRowKeys, TableView } from 'owa-mail-list-store';
import { raiseAction } from 'satcheljs/lib/legacy/stitch';

/**
 * The action which marks conversations as junk.
 * @param conversationRowKeys - the conversations rows to mark as junk
 * @param tableView - the table view the conversations are from
 * @param isJunkValueToSet - whether it is a mark as junk or not junk action
 * @param actionSource - the source that initiated the action call
 */
export default function markConversationsJunkNotJunkFromTable(
    conversationRowKeys: string[],
    tableView: TableView,
    isJunkValueToSet: boolean,
    actionSource: ActionSource
) {
    // the itemIds need to be retrieved before the store update, otherwise it might get removed
    const itemIdsToUpdate = getItemIdsFromConversations(conversationRowKeys, tableView.id);
    const instrumentationContexts = getInstrumentationContextsFromTableView(
        conversationRowKeys,
        tableView
    );

    markItemsJunkNotJunkBasedOnItemIds(
        itemIdsToUpdate,
        isJunkValueToSet,
        actionSource,
        tableView,
        instrumentationContexts,
        () => {
            // remove conversation from list view and reading pane store
            const conversationIds = getRowIdsFromRowKeys(conversationRowKeys, tableView.id);
            raiseAction<DeleteConversationStoreUpdate>(actionNames.DeleteConversationStoreUpdate)(
                conversationIds,
                tableView
            );
        }
    );
}
